// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegenerateMemoMutationVariables = Types.Exact<{
  input: Types.RegenerateMemoInput;
}>;


export type RegenerateMemoMutation = { __typename?: 'Mutation', regenerateMemo: { __typename?: 'WorkflowTracker', id: string, kind: Types.WorkflowTrackerKind, status: Types.WorkflowTrackerStatus, startedAt: Time } };

export const Operations = {
  Mutation: {
    RegenerateMemo: 'RegenerateMemo' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const RegenerateMemoDocument = gql`
    mutation RegenerateMemo($input: RegenerateMemoInput!) {
  regenerateMemo(input: $input) {
    id
    kind
    status
    startedAt
  }
}
    `;
export type RegenerateMemoMutationFn = Apollo.MutationFunction<RegenerateMemoMutation, RegenerateMemoMutationVariables>;

/**
 * __useRegenerateMemoMutation__
 *
 * To run a mutation, you first call `useRegenerateMemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateMemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateMemoMutation, { data, loading, error }] = useRegenerateMemoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegenerateMemoMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateMemoMutation, RegenerateMemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateMemoMutation, RegenerateMemoMutationVariables>(RegenerateMemoDocument, options);
      }
export type RegenerateMemoMutationHookResult = ReturnType<typeof useRegenerateMemoMutation>;
export type RegenerateMemoMutationResult = Apollo.MutationResult<RegenerateMemoMutation>;
export type RegenerateMemoMutationOptions = Apollo.BaseMutationOptions<RegenerateMemoMutation, RegenerateMemoMutationVariables>;